module.exports = __webpack_public_path__ + "static/media/payment.6c5da986.svg";